import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const AlarmDeleteIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				d="M8.5 4.949a.75.75 0 0 0-1.5 0v3c0 .414.336.75.75.75h3a.75.75 0 0 0 0-1.5H8.5z"
			></path>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M7.75 2.5a5.5 5.5 0 0 0-.688 10.958.75.75 0 1 1-.185 1.488 7.001 7.001 0 1 1 7.82-7.806.75.75 0 1 1-1.488.183A5.5 5.5 0 0 0 7.75 2.5"
				clipRule="evenodd"
			></path>
			<path
				fill="currentColor"
				d="m10.53 9.72-.084-.073a.75.75 0 0 0-.976 1.133l1.47 1.47-1.47 1.47a.75.75 0 0 0 1.06 1.06L12 13.31l1.47 1.47.084.073a.75.75 0 0 0 .976-1.133l-1.47-1.47 1.47-1.47a.75.75 0 1 0-1.06-1.06L12 11.19z"
			></path>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M3.63.504a.75.75 0 0 1-.177 1.046 8 8 0 0 0-1.845 1.83.75.75 0 1 1-1.216-.877A9.5 9.5 0 0 1 2.585.326a.75.75 0 0 1 1.046.178Zm8.737 0a.75.75 0 0 0 .177 1.046 8 8 0 0 1 1.845 1.83.75.75 0 0 0 1.216-.877A9.5 9.5 0 0 0 13.412.326a.75.75 0 0 0-1.046.178Z"
				clipRule="evenodd"
			></path>
		</svg>
	),
)
